export enum AuthConstants {
  TOKEN_HOST = 'farmportal',
  AGROSELL_HOST = 'AgroSell',
  LOGO_URL = '/assets/images/logo.svg'
}
